import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  trialTitle: 'Start your 7-day <br><mark>free trial</mark> today.',
  planTitle: (planName: string) =>
    `Start your <mark>${planName}</mark> subscription`,
  email: 'Email',
  emailPlaceholder: 'name@example.com',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  name: 'Full name',
  namePlaceholder: 'John Smith',
  acceptTerms: 'I agree to the',
  termsAndPrivacy: 'terms & conditions.',
  submit: 'Sign up',
  submitTrial: 'Start your 7-day free trial',
};

const welsh = {
  trialTitle: 'Dechreuwch eich <mark>treial am ddim</mark> 7 diwrnod heddiw.',
  planTitle: (planName: string) =>
    `Dechreuwch eich tanysgrifiad <mark>${planName}</mark>`,
  email: 'e-bost',
  emailPlaceholder: 'name@example.com',
  password: 'Cyfrinair',
  passwordPlaceholder: 'Rhowch eich cyfrinair',
  name: 'Enw llawn',
  namePlaceholder: 'John Smith',
  acceptTerms: "Rwy'n cytuno i",
  termsAndPrivacy: 'Telerau ac amodau',
  submit: 'Cofrestru',
  submitTrial: 'Dechreuwch eich treial 7 diwrnod am ddim',
};

export const signupText: any = getLocalizationBasedOnLang(english, welsh);
